import {Toast} from 'mint-ui';
let setting = {
    type: '', // 网络类型
    connect: window.navigator.connection || null,
    ua: window.navigator.userAgent,
    isOnline: window.navigator.onLine,
    offLineHanler: () => {
        Toast('您目前处于无网络状态，请检查网络！');
    },
    typeChangeHandler: () => {
        Toast('您的网络有变化~');
    }
}
export function offLineLister() {
    let oldOnLineType = window.navigator.onLine;
    if (setting.connect) {
        setting.connect.onchange = function () {
            document.dispatchEvent(new Event('network_change'))
        }
    } else {
        setInterval(function() {
            if (oldOnLineType !== window.navigator.onLine) {
                oldOnLineType = window.navigator.onLine;
                document.dispatchEvent(new Event('network_change'))
            }
        }, 2000)
    }
};
export function connectNetType() {
    // 只能用于移动设备网络状态检测
    // bluetooth
    // cellular
    // ethernet
    // none
    // wifi
    // other
    // unknown
    let connection = setting.connect;
    if (connection) {
        alert(connection.type)
        return connection.type;
    } else {}
};
export function wxNetType() {
    // debugger
    if (/NetType/.test(setting.ua)) {
        let netType = setting.ua.match(/NetType\/(\S*)/) ;
        if (netType.indexOf('WIFI') >=0 ){
            return 'wifi';
        } else if (netType.indexOf('4G') >=0 ) {
            return '4g';
        } else if (netType.indexOf('3G') >=0 ) {
            Toast('您当前的网络是3g哦~建议打开WiFi网络录音效果更佳');
            return '3g';
        } else if (netType.indexOf('2G') >=0 ) {
            Toast('您当前的网络是2g哦，建议打开WiFi网络录音效果更佳');
            return '2g';
        } else {
            if (!setting.isOnline) {
                Toast('网络异常，请检查后重试~');
                return 'none';
            }
        }
    }
    return '';
};
export function netTypeChange() {
    setting.connect && setting.connect.addEventListener('ontypechange', (e) => {
        
    });
}

export function isOnline() {
    return window.navigator.onLine
}


// WEBPACK FOOTER //
// ./src/common/util/network.js